import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import * as authActions from "../../actions/auth";
import * as userActions from "../../actions/user";

import { bindActionCreators } from "redux";
import { Dialog, DialogContent } from "@material-ui/core";
import colors from "../../styles/colors";
import ActionButton from "../common/ActionButton";

import { signIn } from "../../services/auth";
import UserService from "../../services/user";
import NormalBigButton from "../common/NormalBigButton";
import jwtDecode from "jwt-decode";
import config from "../../config";

const SessionTimeout = withRouter((props) => {
  const [dialogVisible, setDialogVisible] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const authRefresh = localStorage.getItem("refreshToken");
  const timeLeft = localStorage.getItem("timeLeft");

  //Track page changes via the route and send a keep alive as the user navs through the app

  useEffect(() => {
    //As long as the current route is not the login page or public signup pages.
    //Send a keepalive to server when route changes
    if (
      props.location &&
      props.location.pathname &&
      props.location.pathname !== "/" &&
      props.auth &&
      authRefresh &&
      authRefresh !== ""
    ) {
      UserService()
        .refreshUserAuth(authRefresh)
        .then(() => setDialogVisible(false));
    }
  }, [props.location, props.location.pathname]);
  const reAuth = () => {
    setLoading(true);
    setError("");
    signIn(email, password, async (ret) => {
      setLoading(false);
      setPassword("");
      if (ret.error) {
        setError(ret.error_description);
      } else {
        const jwt = jwtDecode(ret.id_token);
        const timeLeft = (jwt.exp - jwt.iat) * 1000; //Take difference and convert to milliseconds

        props.setAllAuthValues(
          ret.id_token,
          ret.refresh_token,
          jwt.iat,
          timeLeft
        );
      }
    });
  };

  const keepAlive = () => {
    UserService()
      .refreshUserAuth(authRefresh)
      .then(() => setDialogVisible(false));
  };

  useEffect(() => {
    if (props.auth.timerRunning) {
      if (Math.trunc(timeLeft / 1000 / 60) < 2) {
        //At two minutes before expiration, show the popup
        setDialogVisible(true);
      }
    } else {
      setDialogVisible(false);
    }
    //If page is not login and timer is at zero// logout
    let path = props.location.pathname.split("/");

    if (
      config.env === "prod" &&
      props.location.pathname !== "/" &&
      path[1] !== "NPS" &&
      path[1] !== "physioVideo" &&
      path[1] !== "password-reset" &&
      path[1] !== "token-invalid" &&
      timeLeft <= 0
    ) {
      props.stopAuthTimer();
      props.userLogOut();
      props.history.replace("/");
    }
  }, [timeLeft, props.auth.timerRunning, props.history.pathname]);

  return (
    <div>
      <Dialog open={dialogVisible}>
        <DialogContent>
          <div>
            {props.auth.timeLeft > 0 && (
              <div>
                <h1
                  style={{
                    fontFamily: "Poppins-Regular",
                    color: colors.primary,
                    fontSize: 24,
                  }}
                >
                  Are you still there?
                </h1>
                <p
                  style={{
                    fontFamily: "Poppins-Regular",
                    fontSize: 16,
                  }}
                >
                  We noticed you haven't been active recently. To keep your
                  session active please press below.
                </p>
                <p
                  style={{
                    fontFamily: "Poppins-Regular",
                    fontSize: 16,
                    marginVertical: 20,
                    textAlign: "center",
                  }}
                >
                  Session Expires In:{" "}
                  {Math.trunc(props.auth.timeLeft / 1000 / 60) + " min"}{" "}
                  {Math.trunc((props.auth.timeLeft / 1000) % 60) + " sec"}
                </p>
                <ActionButton
                  onClick={() => {
                    keepAlive();
                  }}
                  style={{
                    width: "100%",
                    backgroundColor: colors.primary,
                    color: "white",
                  }}
                  label="I Am Here"
                ></ActionButton>
              </div>
            )}
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ ...authActions, ...userActions }, dispatch);
}

const mapStateToProps = ({ auth }, props) => ({
  auth,
  ...props,
});

export default connect(mapStateToProps, mapDispatchToProps)(SessionTimeout);



// WEBPACK FOOTER //
// ./src/components/auth/SessionTimeout.js